import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import CurrencyLedger from "../components/CurrencyLedger";

function parsePair(v) {
  const [app, id] = (v || "").split(":");
  return app && id ? { app, id } : null;
}

export default function LedgerTilePopout() {
  const [params] = useSearchParams();
  const { token, loading } = useApp();
  const a = parsePair(params.get("a"));
  const b = parsePair(params.get("b"));
  if (loading) return <div className="grid min-h-screen place-items-center opacity-60">Loading…</div>;
  if (!token) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-white p-3 dark:bg-[#0b1020]" data-testid="ledger-tile-page">
      <h1 className="mb-2 font-head text-lg">Reconcile — side by side</h1>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        {[a, b].map((acc, i) => (
          <div key={i} className="rounded-lg border border-black/10 dark:border-white/10 p-2" data-testid={`tile-panel-${i}`}>
            {acc ? <CurrencyLedger app={acc.app} accountId={acc.id} popout />
              : <div className="p-6 text-center text-sm opacity-50">No account selected for this pane.</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
